import request from '../utils/request';

export default {

  queryKhxxByKhnbid(khnbid) {
    return request.get(`/khmk/khzh/${khnbid}`);
  },

  queryYhxx(params) {
    return request.get('/open/kh/yh', params);
  },

  updateKhEmail(params) {
    return request.put('/khmk/kh/email', params);
  },

  updateKhPhone(params) {
    return request.put('/khmk/kh/phone', params);
  },

  queryZhfwlb() {
    return request.get('/open/zhfwlb');
  },

  queryQfye() {
    return request.get('/khmk/kh/qfye');
  },

  queryJldxxList() {
    return request.get('/khmk/kh/dzxx');
  },

  queryJldxxDetails(params) {
    return request.get('/khmk/kh/jld', params);
  },

  /* updateKhzhxx(params) {
    return request.put('/khmk/kh/phone_new', params);
  }, */

  updateKhzhxx(params) {
    return request.put('/khmk/kh/phone_new', params);
  },

  querybjfw(params) {
    return request.get('/khmk/kh/querybjfw', params);
  },

};



// WEBPACK FOOTER //
// ./src/api/khmk.api.js